export const SLICE_NAME = 'poynt';
